import _ from 'lodash';
import angular from 'angular';
import logger from '../../../shared/logger';
import { RECRUITER_WORKFLOW_STATUS } from '../constants/recruiter-workflow';
import { CANDIDATE_FEEDBACK_STATUSES } from '../constants/feedback';

const RecruiterWorkflowStepResolver = (WorkflowService, PositionService, RecruiterService) => {
    const getWorkflowStep = async (positionId, recruiterId) => {
        const position = await getPosition(positionId, recruiterId);
        const {
            claimedCount,
            sentCount,
            readyCount,
            engagedCount,
        } = getPositionCounters(position);

        if (sentCount > 0) {
            return RECRUITER_WORKFLOW_STATUS.SENT;
        }

        if (readyCount > 0) {
            return RECRUITER_WORKFLOW_STATUS.READY;
        }

        if (engagedCount > 0) {
            return RECRUITER_WORKFLOW_STATUS.ENGAGED;
        }

        const positionFeedbackCount = await getPositionFeedbackCount(positionId);

        if (positionFeedbackCount > 0) {
            return RECRUITER_WORKFLOW_STATUS.FEEDBACK;
        }

        if (claimedCount > 0) {
            return RECRUITER_WORKFLOW_STATUS.CLAIMED;
        }

        return RECRUITER_WORKFLOW_STATUS.PROSPECT;
    };

    const getPosition = async (positionId, recruiterId) => {
        const { result: [ position ] } = await RecruiterService.getRecruiterWorkflowCounters(recruiterId, {
            positionIDs: [positionId],
        });

        return position;
    };

    const getPositionCounters = ({ table = []}) => {
        const claimedCount = getPositionStatusCounter(table, RECRUITER_WORKFLOW_STATUS.CLAIMED);
        const sentCount = getPositionStatusCounter(table, RECRUITER_WORKFLOW_STATUS.SENT);
        const readyCount = getPositionStatusCounter(table, RECRUITER_WORKFLOW_STATUS.READY);
        const engagedCount = getPositionStatusCounter(table, RECRUITER_WORKFLOW_STATUS.ENGAGED);

        return {
            claimedCount,
            sentCount,
            readyCount,
            engagedCount,
        };
    };

    const getPositionStatusCounter = (table, workflowStatus) => {
        const counter = table.find(({ status }) => status === workflowStatus);

        if (!counter) {
            return 0;
        }

        return counter.count;
    };

    const getPositionFeedbackCount = async (positionId) => {
        try {
            const { result: workflows } = await WorkflowService.getWorkflowSearch({ positionId });
            const { result: positionData } = await PositionService.getPosition(positionId);
            const feedbackOnCandidates = _.get(positionData, 'feedbackOnCandidates');

            const feedbackWorkflows = (workflows || [])
                .filter(({ events }) => {
                    const requestFeedbackEvent = _.findIndex(events, {eventType: WorkflowService.eventTypes.REQUEST_FEEDBACK});
                    const backToProspects = _.findIndex(events, {eventType: WorkflowService.eventTypes.BLOCK_REQUEST_FEEDBACK});
                    const onlyRequestFeedbackEventExist = (requestFeedbackEvent >= 0 && backToProspects < 0);
                    const prospectsEventBeforeRequestFeedbackEvent = (requestFeedbackEvent >= 0 && requestFeedbackEvent < backToProspects);

                    return onlyRequestFeedbackEventExist || prospectsEventBeforeRequestFeedbackEvent;
                });

            const sendedFeedbackWorkflowsCount = feedbackWorkflows
                .map(workflow => (feedbackOnCandidates || []).find((feedback) =>
                    feedback.status && feedback.candidateId === workflow.candidateId))
                .filter(feedback => feedback)
                .reduce((totalCount, { status }) => {
                    const isStatusNotAccepted = status !== CANDIDATE_FEEDBACK_STATUSES.ACCEPTED;
                    const isStatusNotPending = status !== CANDIDATE_FEEDBACK_STATUSES.PENDING;
                    const isStatusNotAcceptedOrPending = isStatusNotAccepted || isStatusNotPending;

                    if (isStatusNotAcceptedOrPending) {
                        return totalCount + 1;
                    }

                    return totalCount;
                }, 0);

            return feedbackWorkflows.length - sendedFeedbackWorkflowsCount;
        } catch (error) {
            logger.error(error);
        }

        return 0;
    };

    return {
        getWorkflowStep,
    };
};

angular.module('TALENYA-FE').factory('RecruiterWorkflowStepResolver', RecruiterWorkflowStepResolver);
